export const DATA_CATEGORIES = {
    temperature: {
        agristarMetric: true,
        label: "Temperature",
        color: "#ff6b6b",
        unit: "°F",
        options: [
            { key: "plenumTempSetpoint", label: "Plenum Set Point" },
            { key: "burnerSetpoint", label: "Burner Set Point" },
            { key: "plenumTemp", label: "Plenum Temp" },
            { key: "outsideTemp", label: "Outside Temperature" },
            { key: "remoteTemp", label: "Remote Temperature" },
            { key: "returnTemp", label: "Return Temperature" },
            { key: "pileTemp1", label: "Pile Temperature 1" },
            { key: "pileTemp2", label: "Pile Temperature 2" },
            { key: "pileTemp3", label: "Pile Temperature 3" },
        ]
    },
    humidity: {
        agristarMetric: true,
        label: "Percentage",
        color: "#4ecdc4",
        unit: "%",
        options: [
            { key: "fanSpeed", label: "Fan Speed" },
            { key: "coolingAvailable", label: "Cooling Available" },
            { key: "plenumHumidSetpoint", label: "Plenum Humidity Set Point" },
            { key: "plenumHumid", label: "Plenum Humidity" },
            { key: "outsideHumid", label: "Outside Humidity" },
            { key: "remoteHumid", label: "Remote Humidity" },
            { key: "returnHumid", label: "Return Humidity" },
            { key: "calculatedHumidity", label: "Calculated Humidity" },
            { key: "humidityReferenceSensor", label: "Humidity Reference Sensor" },
            { key: "pileHumid1", label: "Pile Humidity 1" },
            { key: "pileHumid2", label: "Pile Humidity 2" },
            { key: "pileHumid3", label: "Pile Humidity 3" },
            { key: "burnerThreshold", label: "Burner Threshold" },
            { key: "coolingOutput", label: "Cooling/Ref Output" }
        ]
    },
    co2: {
        agristarMetric: true,
        label: "CO2",
        color: "#ffcc5c",
        unit: "ppm",
        options: [
            { key: "co2Level", label: "CO2 Level" },
        ]
    },
    calculations: {
        agristarMetric: true,
        label: "Calculations",
        color: "#ffcc5c",
        unit: "deltaT",
        options: [
            { key: "deltaT", label: "Delta T" },
        ]
    },
    other: {
        agristarMetric: true,
        label: "Other Metrics",
        color: "#96ceb4",
        unit: "",
        options: [
            { key: "alarms", label: "Alarms" },
            { key: "mode", label: "Current Mode" },
            { key: "dailyFanRun", label: "Daily Fan Runtime" },
        ]
    },
    service: {
        agristarMetric: false,
        label: "Service History",
        color: "#ff9f43",
        unit: "",
        options: [
            { key: "sheets", label: "Service Sheets" },
            { key: "inspections", label: "Inspections" },
            { key: "chemAppAgreement", label: "Custom Application Agreement" },
            { key: "disinfectantAgreement", label: "Disinfectant Agreement" },
            { key: "sprayBarAgreement", label: "Spray Bar Agreement" },
            { key: "freshPack", label: "Fresh Pack" },
            { key: "refrigeration", label: "Refrigeration" },
            { key: "preseason", label: "Preseason" },
            { key: "labData", label: "Labs" },
        ]
    },
    sucrose: {
        agristarMetric: false,
        label: "Sucrose",
        color: "#f7f7f7",
        unit: "sucrose",
        options: [
            { key: "sucrose-0", label: "Sucrose 0" },
            { key: "sucrose-1", label: "Sucrose 1" },
            { key: "sucrose-2", label: "Sucrose 2" },
            { key: "sucrose-3", label: "Sucrose 3" },
            { key: "sucrose-4", label: "Sucrose 4" },
        ]
    },
    glucose: {
        agristarMetric: false,
        label: "Glucose",
        color: "#f7f7f7",
        unit: "glucose",
        options: [
            { key: "glucose-0", label: "Glucose 0" },
            { key: "glucose-1", label: "Glucose 1" },
            { key: "glucose-2", label: "Glucose 2" },
            { key: "glucose-3", label: "Glucose 3" },
            { key: "glucose-4", label: "Glucose 4" },
        ]
    }
};